import { render, staticRenderFns } from "./abnormalRelease.vue?vue&type=template&id=faf85d1a&scoped=true&"
import script from "./abnormalRelease.vue?vue&type=script&lang=js&"
export * from "./abnormalRelease.vue?vue&type=script&lang=js&"
import style0 from "./abnormalRelease.vue?vue&type=style&index=0&id=faf85d1a&scoped=true&lang=css&"
import style1 from "./abnormalRelease.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf85d1a",
  null
  
)

export default component.exports